/**
 * Route Key Mapping
 *
 * Maps route names (from NavigationKey enum values) to their corresponding
 * property keys used in ClaimsService.updateClaimReport() calls.
 *
 * Generated by analyzing all updateClaimReport() calls throughout the codebase.
 */

import { ClaimReport } from './interfaces/claim-report';

export const keyRouteMap: Record<keyof ClaimReport, string> = {
  // Accident Report Flow
  'userType': 'user-participation',
  'externalsInvolved': 'multiple-party-involvement',
  'licensePlate': 'enter-license-plate',
  'incidentAddress': 'accident-location',
  'claimType': 'damage-type',
  'accidentRoleType': 'accident-role',
  'vehicleType': 'vehicle-involved',
  'vehicleIncidentStatusType': 'vehicle-accident-status',
  'involvedCarParts': 'car-part-involved',
  'incidentTypes': 'incident-description',
  'detailedDescription': 'incident-description-detail',

  // Ride Information Flow
  'rideReason': 'ride-reason',
  'age': 'driver-age',
  'isActiveRider': 'active-ride',
  'hasConsumedDrugs': 'alcohol-consumption',
  'policeReportWasIssued': 'police-report',
  'noPoliceReportReason': 'police-report',
  'policeDrugTestPerformed': 'police-drug-test',
  'witnessesAreKnown': 'witness-details',
  'technicalIssue': 'technical-issue',
  'fault': 'who-is-to-blame',
  'thirdPartyEntities': 'third-party-information',

  // Document Upload Flow
  'fileUploads': 'document-upload-overview',
  'policeReportAvailable': 'document-upload-police-report',
  'policeReportImageUrls': 'document-upload-police-report',
  'policeReportNotAvailableReason': 'document-upload-police-report',

  // Personal Information Flow
  'personalInformation': 'personal-information',

  // Data Validation Flow
  'userHasConfirmedCorrectnessOfData': 'data-correctness-confirmation',

  // Overview Flow
  'isVerified': 'contact-validation',
  'incidentDate': 'accident-location',

  'witnesses': 'witness-details',
  'technicalIssueExplanation': 'technical-issue',
};

export const routeKeyMap: Record<string, keyof ClaimReport> = Object.entries(keyRouteMap)
  .reduce((acc, [key, value]) => {
    if (value) {
      // @ts-ignore no proper type check needed. This is just a reverse mapping
      acc[value] = key;
    }
    return acc;
  }, {} as Record<string, keyof ClaimReport>);

/**
 * Helper function to get the property key for a given route
 */
export function getPropertyKeyForRoute(route: string): string | undefined {
  return routeKeyMap[route];
}

/**
 * Helper function to get all routes that update a specific property
 */
export function getRoutesForProperty(propertyKey: string): string[] {
  return Object.entries(routeKeyMap)
    .filter(([, value]) => value === propertyKey)
    .map(([key]) => key);
}

/**
 * Get all available route keys
 */
export function getAllRouteKeys(): string[] {
  return Object.keys(routeKeyMap);
}

/**
 * Get all available property keys
 */
export function getAllPropertyKeys(): string[] {
  return [...new Set(Object.values(routeKeyMap))];
}
